const AUTH_EMAIL_PATHS = new Set(["/auth", "/signin", "/register"]);

export const AUTH_EXIT_EVENT = "greydates:auth-exit";
export const AUTH_SLIDE_MS = 880;

let authEntrySlidePlayed = false;

export function shouldPlayAuthEntrySlide() {
  if (authEntrySlidePlayed) return false;
  authEntrySlidePlayed = true;
  return true;
}

export function resetAuthEntrySlideIfLeavingAuth(pathname) {
  if (!AUTH_EMAIL_PATHS.has(pathname)) {
    authEntrySlidePlayed = false;
  }
}

export function isAuthEmailPath(pathname) {
  return AUTH_EMAIL_PATHS.has(pathname);
}
